import React, {ReactNode} from "react";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

export class InsertIcon extends PortalPureComponent<AnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox="0 0 64 64"
				 style={{
					 opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					 transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
				 }}>
				<path d="M 32.003143,1.4044602 57.432701,62.632577 6.5672991,62.627924 z"
					  style={{
						  fill: this.props.color,
						  fillOpacity: 0.5,
						  fillRule: "nonzero",
						  stroke: "#000000",
						  strokeWidth: 1.5,
						  strokeMiterlimit: 4,
						  strokeOpacity: 1,
						  strokeDasharray: "none"
					  }}/>
			</svg>
		);
	}
}